import React from 'react';
const PipeTee2Icon = ({ width = 64, height = 64 }) => {
  const id = React.useId().replace(/:/g, '');
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 112.5 112.5">
      <defs>
        <linearGradient id={`${id}_1`} gradientUnits="userSpaceOnUse" x1="56.2505" y1="112.5" x2="56.2505" y2="56.2505">
          <stop offset="0.01" stopColor="#646464" />
          <stop offset="0.16" stopColor="#8F8F8F" />
          <stop offset="0.49" stopColor="#DFDFDF" />
          <stop offset="1" stopColor="#646464" />
        </linearGradient>
        <linearGradient id={`${id}_2`} gradientUnits="userSpaceOnUse" x1="28.125" y1="42.4429" x2="84.375" y2="42.4429">
          <stop offset="0.01" stopColor="#646464" />
          <stop offset="0.18" stopColor="#949494" />
          <stop offset="0.5" stopColor="#DFDFDF" />
          <stop offset="1" stopColor="#656565" />
        </linearGradient>
      </defs>
      <path fill={`url(#${id}_1)`} d="M0,56.25v56.25h112.5V56.25H0z" />
      <polygon fill={`url(#${id}_2)`} points="28.125,0 28.125,57.25 56.495,84.886 84.375,56.271 84.375,0" />
    </svg>
  );
};
export default PipeTee2Icon;
